import {  UAlogo } from "../assests";
import { cart } from "../assests";
import { Link } from "react-router-dom";
import {useSelector} from "react-redux";

const Header=()=>{
   const productData=useSelector((state)=>state.bazar.productData)
   const userInfo=useSelector((state)=>state.bazar.userInfo)
   console.log(userInfo)
   console.log(productData);
    return(<div className="w-full h-20  bg-white border-b-[1px] border-b-gray-800 font-titleFont sticky top-0 z-50 ">
    <div className="max-w-screen-xl h-full mx-auto flex items-center justify-between">
          <Link to="/">
          <div>
            <img  className="w-28"src={UAlogo} alt="LOGO" />
          </div>
          </Link>
          <div className="flex items-center gap-8">
       <ul className="flex items-center gap-8">
         <Link to='/'>
        <li className="text-base text-black font-bold hover:text-orange-600 hover:underline underline-offset-2 decoration-[1px] cursor-pointer duration-300">Home</li>
        </Link>
        <li className="text-base text-black font-bold hover:text-orange-600 hover:underline underline-offset-2 decoration-[1px] cursor-pointer duration-300">Pages</li>
        <li className="text-base text-black font-bold hover:text-orange-600 hover:underline underline-offset-2 decoration-[1px] cursor-pointer duration-300">Shop</li>
        <li className="text-base text-black font-bold hover:text-orange-600 hover:underline underline-offset-2 decoration-[1px] cursor-pointer duration-300">Element</li>
        <li className="text-base text-black font-bold hover:text-orange-600 hover:underline underline-offset-2 decoration-[1px] cursor-pointer duration-300">Blog</li>
       </ul>
       <Link to="/cart">
     <div className="relative">
        <img src={cart} className="w-12" alt="image" />
        <span className="absolute top-3 right-12"><div className="border border-black px-1 bg-black text-white rounded-full ">{productData.length} </div></span>     
     </div>
     </Link>
     <Link to="/login">
     <img className="w-8 h-8 rounded-full border border-red-400" src={ userInfo? userInfo.image: UAlogo} alt="idimage" />
     </Link>
     {
      userInfo&&<p className="mr-4 underline font-bold">{userInfo.name}</p>
     }
    </div>
    </div>




    
    </div>);
}
export default Header;